/** CMS-CRC-4 — QR payload may be raw base64 or a data URL. */
export function coverNoteQrImageSrc(qr: string | null | undefined): string {
  const value = qr?.trim() ?? '';
  if (!value) return '';
  if (value.startsWith('data:')) return value;
  return `data:image/png;base64,${value}`;
}
